const calculator = require('./calculator')
const classes = require('./classes')
const config = require('./config')
const formatting = require('./formatting')
const regex = require('./regex')
const utils = require('./utils')
const validation = require('./validation')
const webpack = require('./webpack')

module.exports = {
  ...calculator,
  ...classes,
  ...config,
  ...formatting,
  ...regex,
  ...utils,
  ...validation,
  ...webpack
}
